export enum EnumPresionTension {
    BajaTension = 7,
    AltaTension = 8,
    NP0Satelite = 10,
    NP0 = 11,
    NP1 = 12,
    NP2 = 13,
    NP3 = 14
}